import { DownOutlined, UpOutlined } from "@ant-design/icons";
import { Spin } from "antd";
import { useState } from "react";

const ARSummary = ({ loading, storeIdData, primaryColor }) => {
  const [isAuditSummaryOpen, setIsAuditSummaryOpen] = useState(true);
  const [expanded, setExpanded] = useState(false);

  return (
    storeIdData?.report_summary?.length > 0 && (
      <div className="card">
        <div
          className="card-header"
          onClick={() => setIsAuditSummaryOpen((prev) => !prev)}
          style={{
            backgroundColor: primaryColor || undefined,
            color: primaryColor ? "#fff" : undefined,
          }}
        >
          <p>Report Summary</p>
          {!isAuditSummaryOpen ? <UpOutlined /> : <DownOutlined />}
        </div>
        {isAuditSummaryOpen && (
          <div className="body-content p-2 mt-2" style={{ fontSize: "15px" }}>
            {loading ? (
              <Spin size="small" />
            ) : (
              <>
                <p
                  className={`report-summary-text ${expanded ? "expanded" : ""} m-0 px-2`}
                >
                  {storeIdData?.report_summary || "No report summary available"}
                </p>
                {storeIdData?.report_summary?.length > 50 && (
                  <button
                    type="button"
                    className="show-more-btn"
                    onClick={() => setExpanded((prev) => !prev)}
                  >
                    {expanded ? "Show Less" : "Read More"}
                  </button>
                )}
              </>
            )}
          </div>
        )}
      </div>
    )
  );
};

export default ARSummary;
